module.exports = __webpack_public_path__ + "img/ht.c63df092.jpg";